import React from 'react'

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js'
import { Bar } from 'react-chartjs-2'

import { FORMAT } from 'utils'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

interface VerticalBarProps {
  values: [number, number, number, number]
  labelsData: [string, string, string, string]
}

const VerticalBarChart: React.FC<VerticalBarProps> = ({
  values,
  labelsData
}) => {
  const labels = ['']
  return (
    <Bar
      options={{
        maintainAspectRatio: false,
        plugins: {
          legend: {
            align: 'center',
            position: 'bottom'
          },
          datalabels: {
            formatter: function (value, context) {
              return FORMAT.currency(value)
            },
            align: 'top',
            color: 'black'
          },
        }
      }}
      data={{
        datasets: [
          {
            backgroundColor: '#8ED6C5',
            data: labels.map(() => values[0]),
            label: labelsData[0]
          },
          {
            backgroundColor: '#C0DDB1',
            data: labels.map(() => values[1]),
            label: labelsData[1]
          },
          {
            backgroundColor: '#F9DFCE',
            data: labels.map(() => values[2]),
            label: labelsData[2]
          },
          {
            backgroundColor: '#f5a0a0',
            data: labels.map(() => values[3]),
            label: labelsData[3]
          }
        ],
        labels
      }}
    />
  )
}

export default VerticalBarChart
